import React from 'react'
import { Edit, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import SectionTitle from '../components/SectionTitle'

const styles = {
  textInput: { width: 500 },
}

const useStyles = makeStyles(styles)

const TagEdit = (props) => {
  const classes = useStyles()
  return (
    <Edit {...props}>
      <SimpleForm>
        <SectionTitle label="Edit Tag" />
        <ReferenceInput source="tagTypeId" reference="tag-types" label="Tag Type" required>
          <SelectInput optionText="name" formClassName={classes.textInput} fullWidth disabled />
        </ReferenceInput>
        <TextInput source="name" formClassName={classes.textInput} fullWidth required />
        <TextInput source="description" formClassName={classes.textInput} fullWidth multiline rows={3} />
      </SimpleForm>
    </Edit>
  )
}

export default TagEdit

